import { render, staticRenderFns } from "./test-service-online-delegation.vue?vue&type=template&id=3f926ad2&scoped=true"
import script from "./test-service-online-delegation.vue?vue&type=script&lang=js"
export * from "./test-service-online-delegation.vue?vue&type=script&lang=js"
import style0 from "./test-service-online-delegation.vue?vue&type=style&index=0&id=3f926ad2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f926ad2",
  null
  
)

export default component.exports